module.exports = require("@swa-ui/core/src/OptionList/OptionList.module.scss");